import { arrayOf, shape } from 'prop-types'

import MenuSection from 'views/components/organisms/HeaderNew/MenuSection'

const banners = [
  {
    title: 'MyTherapy App',
    imageURL:
      'https://static.shop-apotheke.com/media/content/80x80/myTherapy.png',
    text: 'Einnahmeerinnerung & - tagebuch für Ihre Medikamente - hier App herunterladen!',
    link: '/medikamenten-app/',
  },
]

const HealthServices = ({ menuLinks }) => (
  <MenuSection
    menuLinks={menuLinks}
    banners={banners}
    boxClasses="u-padding-small--right@small-tiny"
    cardClasses="l-col--3-of-12@medium"
    titleWrapperClasses="l-col--3-of-12@medium"
  />
)

HealthServices.propTypes = {
  menuLinks: arrayOf(shape({})).isRequired,
}

HealthServices.defaultProps = {}

export default HealthServices
